import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Newspaper, ArrowRight } from "lucide-react";
import { SmartImage } from "@/components/news/SmartImage";

export const HomepageNews = () => {
  const [posts, setPosts] = useState<any[]>([]);

  useEffect(() => {
    supabase
      .from("news_posts")
      .select("id,title,slug,excerpt,featured_image,featured_image_thumb,featured_image_position,category,published_at")
      .eq("status", "published")
      .order("published_at", { ascending: false })
      .limit(3)
      .then(({ data }) => setPosts(data ?? []));
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="section-pad bg-white">
      <div className="container-cws">
        <div className="flex items-end justify-between gap-4 border-b border-border pb-5">
          <div>
            <span className="editorial-kicker">
              <Newspaper className="h-3.5 w-3.5" /> Latest News
            </span>
            <h2 className="news-display mt-3 text-3xl font-extrabold text-charcoal md:text-4xl">News <span className="gradient-text-blue-green">& Updates</span></h2>
          </div>
          <Link to="/news" className="hidden items-center gap-1 text-sm font-semibold text-primary hover:underline sm:inline-flex">
            View all <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-12">
          {posts.map((p, index) => (
            <Link key={p.id} to={`/news/post/${p.slug}`} className={`group overflow-hidden rounded-md border border-border bg-card shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-card ${index === 0 ? "md:col-span-6" : "md:col-span-3"}`}>
              {p.featured_image ? (
                <div className="aspect-[16/9] w-full overflow-hidden bg-secondary/60">
                  <SmartImage src={p.featured_image} thumbSrc={p.featured_image_thumb} alt={p.title} position={p.featured_image_position} wrapperClassName="h-full w-full" portraitContain />
                </div>
              ) : (
                <div className="flex aspect-[16/9] items-center justify-center bg-primary-soft text-primary">
                  <Newspaper className="h-10 w-10" />
                </div>
              )}
              <div className={index === 0 ? "p-6" : "p-5"}>
                <span className="text-[11px] font-semibold uppercase tracking-wide text-primary">{p.category}</span>
                <h3 className={`news-display mt-2 font-bold leading-snug text-charcoal transition-colors group-hover:text-primary ${index === 0 ? "text-xl md:text-2xl" : "text-[17px]"}`}>{p.title}</h3>
                {p.excerpt && <p className="mt-2 line-clamp-2 text-[14px] text-muted-foreground">{p.excerpt}</p>}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
